<template>
  <div v-loading="loading" class="h-viewport" />
</template>

<script>
  import { event } from '@/plugins/event'

  export default {
    data() {
      return {
        loading: false
      }
    },

    computed: {
      token() {
        return this.$route.query.token
      }
    },

    created() {
      this.$store.dispatch('activateAccount', { token: this.token })
        .then(() => {
          this.redirectTo()
          event.$emit('app:init')
        })
        .catch(error => {
          this.$notify.error({
            title: 'Ошибка',
            message: error.response.data.errorMessage
          })
        })
      this.loading = true
    },

    methods: {
      redirectTo() {
        const to = this.$route.query.redirectTo || { name: 'home' }
        this.$router.push(to)
      }
    }
  }
</script>
